var moduleMap = {
	"./serviceCall": () => {
		return Promise.all(/* __federation_expose_serviceCall */[__webpack_require__.e(298), __webpack_require__.e(619), __webpack_require__.e(392), __webpack_require__.e(57)]).then(() => (() => ((__webpack_require__(2826)))));
	},
	"./noauthcall": () => {
		return Promise.all(/* __federation_expose_noauthcall */[__webpack_require__.e(619), __webpack_require__.e(407)]).then(() => (() => ((__webpack_require__(2037)))));
	},
	"./authConfig": () => {
		return Promise.all(/* __federation_expose_authConfig */[__webpack_require__.e(298), __webpack_require__.e(192)]).then(() => (() => ((__webpack_require__(109)))));
	},
	"./userService": () => {
		return __webpack_require__.e(/* __federation_expose_userService */ 714).then(() => (() => ((__webpack_require__(5868)))));
	},
	"./titleService": () => {
		return __webpack_require__.e(/* __federation_expose_titleService */ 311).then(() => (() => ((__webpack_require__(7453)))));
	},
	"./useFeatureFlag": () => {
		return Promise.all(/* __federation_expose_useFeatureFlag */[__webpack_require__.e(298), __webpack_require__.e(619), __webpack_require__.e(643), __webpack_require__.e(392), __webpack_require__.e(620)]).then(() => (() => ((__webpack_require__(7198)))));
	},
	"./getFeatureFlag": () => {
		return Promise.all(/* __federation_expose_getFeatureFlag */[__webpack_require__.e(298), __webpack_require__.e(619), __webpack_require__.e(643), __webpack_require__.e(392), __webpack_require__.e(620)]).then(() => (() => ((__webpack_require__(7198)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};


// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});